import { render, staticRenderFns } from "./ApiTest.vue?vue&type=template&id=08627d39&"
import script from "./ApiTest.vue?vue&type=script&lang=js&"
export * from "./ApiTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports